export default __webpack_public_path__ + "static/media/phone.b28829d9.svg";